export const COP_REPORT_DATA_ISSUE_OPEN_EVENT = 'cop:report-data-issue:open'
export const COP_REPORT_DATA_ISSUE_SUBMIT_EVENT = 'cop:report-data-issue:submit'
export const COP_SEND_EMAIL_OPEN_EVENT = 'cop:send-email:open'

export type SendEmailOpenDetail = {
  email?: string | string[]
}

export function emitSendEmailOpen(detail: SendEmailOpenDetail): void {
  window.dispatchEvent(new CustomEvent(COP_SEND_EMAIL_OPEN_EVENT, { detail }))
}
const COP_REPORT_DATA_ISSUE_PENDING_OPEN_KEY = '__copReportDataIssuePendingOpen'

export type ReportDataIssueContextType = 'site' | 'asset'

export type ReportDataIssueOpenDetail = {
  contextType?: ReportDataIssueContextType
  contextId?: string
  contextName?: string
}

export type ReportDataIssueSubmitDetail = {
  contextType: ReportDataIssueContextType
  contextId?: string
  contextName?: string
  reasonKeys: string[]
  description: string
}

type CopWindowWithPendingOpen = Window & {
  [COP_REPORT_DATA_ISSUE_PENDING_OPEN_KEY]?: ReportDataIssueOpenDetail
}

export function emitReportDataIssueOpen(detail: ReportDataIssueOpenDetail): void {
  const globalWindow = window as CopWindowWithPendingOpen
  globalWindow[COP_REPORT_DATA_ISSUE_PENDING_OPEN_KEY] = detail
  globalWindow.dispatchEvent(new CustomEvent(COP_REPORT_DATA_ISSUE_OPEN_EVENT, { detail }))
}

export function consumePendingReportDataIssueOpen(): ReportDataIssueOpenDetail | undefined {
  const globalWindow = window as CopWindowWithPendingOpen
  const pending = globalWindow[COP_REPORT_DATA_ISSUE_PENDING_OPEN_KEY]
  if (pending) {
    delete globalWindow[COP_REPORT_DATA_ISSUE_PENDING_OPEN_KEY]
  }
  return pending
}
